import { render } from "./CarouselSkill.vue?vue&type=template&id=44563d6e"
import script from "./CarouselSkill.vue?vue&type=script&lang=js"
export * from "./CarouselSkill.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__